import React, { Suspense, lazy, useEffect } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import { useDispatch } from "react-redux";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard";
import Typography from "../../pages/typography";

// context
import { useLayoutState } from "../../context/LayoutContext";

// import IdleTimer from "react-idle-timer";
import { signOut, useUserDispatch } from "../../context/UserContext";
import Settings from "../../pages/settings/settings";
import Permissions from "../../pages/permissions/permissions";
// Developers component lazy load
const Agents = lazy(() => import("pages/agents/agentsCsr"));
const Policies = lazy(() => import("../../pages/policies"));
const Claims = lazy(() => import("pages/claims/claimsCsr"));
const AgentsView = lazy(() => import("pages/agents/agentsView"));

const ClaimsPayments = lazy(() => import("pages/claims/claimsPayments"));
const Providers = lazy(() => import("pages/providers"));
const FirstReport = lazy(() => import("pages/claims/firstReport"));
const ApproveEndorsement = lazy(() =>
  import("pages/approveEndorsement/ApproveEndorsement"),
);
const ApprovePipBills = lazy(() =>
  import("pages/approvePipBills/ApprovePipBills"),
);
const ClaimsView = lazy(() => import("pages/claims/claimsView"));
const ClaimsForms = lazy(() => import("components/ClaimsForms"));
const ClaimsImages = lazy(() => import("components/ClaimsForms/ClaimsImages"));
const Users = lazy(() => import("../../pages/users"));
const Register = lazy(() => import("../../pages/register"));
const PolicyDetails = lazy(() =>
  import("../../pages/policyDetails/PolicyDetails"),
);
const Profile = lazy(() => import("../../pages/myAccount/MyAccountLayout"));
const ApprovePolicies = lazy(() => import("../../pages/approvePolicies"));
const Diary = lazy(() => import("../../pages/diary"));
const WorkFlowList = lazy(() => import("../../pages/workFlowList"));
const SearchResult = lazy(() => import("../../pages/searchResult"));
const Reports = lazy(() => import("../../pages/reports"));
const PolicyView = lazy(() => import("../../pages/policyView/policyView"));
const MoneyBatch = lazy(() => import("../../pages/account/moneyBatch"));
const ReturnBatch = lazy(() => import("../../pages/account/returnBatch"));
const ReverseEndorsement = lazy(() =>
  import("../../pages/admin/reverseEndorsement"),
);
const DepartmentComplaints = lazy(() => import("../../pages/admin/department"));
const Adddepartment = lazy(() => import("../../pages/admin/addDepartment"));
function Layout(props) {
  var classes = useStyles();
  // const [timer, setTimer] = useState(Date.now());
  var userDispatch = useUserDispatch(); //context
  const dispatch = useDispatch(); //redux global store

  // global
  var layoutState = useLayoutState();

  useEffect(() => {
    const currentPath = props.history.location.pathname
      .split("/")
      .filter(function (el) {
        return el !== "" && el !== "app";
      });
    const pageType = currentPath[0] || "";
    const pageModeArr = pageType.split("-");
    dispatch({ type: "PATH_ADDED", payload: pageType });
    dispatch({ type: "PAGE_MODE_ADDED", payload: pageModeArr[0] || "" });
    dispatch({ type: "PAGE_ARGS_ADDED", payload: currentPath });
  }, [props.history.location.pathname]);

  useEffect(() => {
    // if (localStorage.getItem("AUTH_TOKEN"))
    window.addEventListener(
      "mousemove",
      () => {
        localStorage.setItem("updateTimeOut", Date.now());
      },
      false,
    );
    const interval = setInterval(() => {
      let getTimeOut = parseInt(localStorage.getItem("updateTimeOut"));
      let millis = Date.now() - getTimeOut;
      let timeout = Math.floor(millis / 60000);
      if (timeout === 44) {
        clearInterval(interval);
        signOut(userDispatch, props.history);
      }
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classes.root}>
      <>
        <Header {...props} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route path="/app/dashboard" component={Dashboard} />
            <Route path="/app/typography" component={Typography} />
            <Route
              exact
              path="/app/policy"
              render={() => <Redirect to="/app/policy/policy-CSR" />}
            />
            <Route
              path="/app/policy/policy-CSR"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Policies {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/providers/:action?/:providerId?/:fein?"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Providers {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/policy/approve-endorsement"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ApproveEndorsement {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/claims/approve-pip-bills"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ApprovePipBills {...props} />
                </Suspense>
              )}
            />

            <Route
              path="/app/claims/claims-CSR"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Claims {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/claims/fr-CSR"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <FirstReport {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/claims/claims-payments"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsPayments {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/policy/policy-approve"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ApprovePolicies {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/diary"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Diary {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/users"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Users {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/reports"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Reports {...props} />
                </Suspense>
              )}
            />

            <Route
              path="/app/create-user"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Register {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/edit-user"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Register {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/policy-details/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <PolicyDetails {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/policy-view/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <PolicyView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/fr-view/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />

            <Route
              exact={false}
              path="/app/claims/claims-forms/:claimNo?"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsForms {...props} />
                </Suspense>
              )}
            />

            <Route
              exact={false}
              path="/app/claims/claims-images/:claimNo?"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsImages {...props} />
                </Suspense>
              )}
            />

            <Route
              exact={false}
              path="/app/fr-edit/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/fr-move/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/fr-add/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/claims-view/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/claims-add/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/claims-edit/:claimNo/:policyNo"
              render={() => (
                <Suspense fallback={<div>Loading edit...</div>}>
                  <ClaimsView {...props} />
                </Suspense>
              )}
            />
            <Route
              exact={false}
              path="/app/workflow/:mode?/:fileNo?/:imageIndexId?"
              render={() => (
                <Suspense fallback={<div>Loading edit...</div>}>
                  <WorkFlowList {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/myaccount"
              render={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Profile {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/policy/workFlow"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <WorkFlowList {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/search-results"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <SearchResult exact {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/settings"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Settings exact {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/permissions"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Permissions exact {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/account/money-batch"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <MoneyBatch {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/account/return-batch"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ReturnBatch {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/admin/reverse-endorsement"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ReverseEndorsement {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/admin/department-complaints"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <DepartmentComplaints {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/admin/add-department/:indexId/:claimNo"
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Adddepartment {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/agents"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Agents {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/agents/viewSatements"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Agents {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/agents/runStatements"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <Agents {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/agentsView/:id"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <AgentsView {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/agentEdit/:id"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <AgentsView {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/app/newAgent"
              exact
              render={(props) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <AgentsView {...props} />
                </Suspense>
              )}
            />
          </Switch>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
